import { Box, TargetProvider } from "@modernatx/ui-kit-react-v2";
import React from "react";

import { useInitializeRouter } from "@/hooks/useInitializeRouter";
import { useTargetProvider } from "@/hooks/useTargetProvider";

import { Block, BlockPageProps, BlockProps } from "./Block";

interface ContentProps {
  content: BlockPageProps;
}

export const RenderContent: React.FC<ContentProps> = ({ content }) => {
  useInitializeRouter();
  const { handleClick, resolveTarget } = useTargetProvider();

  const blocks = React.useMemo(() => {
    const before: BlockProps[] = [];

    content?.blocks.forEach((block) => {
      before.push(block);
    });

    return { before };
  }, [content?.blocks]);
  return (
    <TargetProvider clickHandler={handleClick} targetResolver={resolveTarget}>
      <Box
        as={"main"}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh"
        }}
      >
        <Box
          as={"div"}
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            contain: "paint"
          }}
        >
          {blocks.before.map((props, i) => (
            <Block key={i} {...props} />
          ))}
        </Box>
      </Box>
    </TargetProvider>
  );
};
